// extracted by mini-css-extract-plugin
module.exports = {"page":"StartPage_page__3fW0N","welcomeSegment":"StartPage_welcomeSegment__lKHsM"};